<template>
<body>
    <div v-bind:class="{ burgerMenuContainer: true, active: showNav }">
    <div @click="mixNav()" class="burgerHeader">
      <a href="#" class="closeMenu"><i class="far fa-times"></i></a>
    </div>
    <div class="burgerBody">
      <nav>
        <ul class="topMenu">
          <li>
            <a href="/#/index" target="_self">
              Home
            </a>
          </li>
          <li>
            <router-link to="/shop" target="_self">
              Shop
            </router-link>
          </li>
          <li class="active">
            <router-link to="/user/account" target="_self">
              Account
            </router-link>
          </li>
          <li class="">
              <router-link to="/how-it-works" target="_self">
                How It Works
              </router-link>
            </li>
        </ul>
      </nav>
    </div>
    <div class="burgerBot">
      <p>supremeaccess | Legal | Disclousure</p>
    </div>
  </div>
  <div class="flexLayoutShop">
    <div class="leftSidebar">
      <div class="logoContainer">
        <router-link to="/index"><img src="../../../assets/images/logo-white.svg" alt="" /></router-link>
      </div>
      <section class="sidebarBot">
        <div class="sideBotBod">
          <div class="sideBotFlexMenu">
            <li>
              <router-link to="/index">Home</router-link>
            </li>
            <li>
              <router-link to="/shop">Shop</router-link>
            </li>
            <li class="active">
              <router-link to="/user/account">Account</router-link>
            </li>
          </div>
          <div class="sidePageTitle">
            <h1>Account</h1>
          </div>
        </div>
      </section>
    </div>
    <div class="flexLayoutBody">
      <!-- <span class="pageTitleOnMobile">Account</span> -->
      <div class="cartSidebar">
        <a href="#" class="closeSidebar"><i class="far fa-times"></i></a>
        <h2>Cart</h2>
        <h2>Select Profile</h2>
        <h2>Order Review</h2>
        <h2>Order Review</h2>
        <div class="itemsInCartGrid">
          <div class="indivItemInCart">
            <div class="itemImg">
              <img src="../../../assets/images/lvs.png" alt="" />
            </div>
            <div class="itemInfo">
              <h4>Supreme Backpack</h4>
              <p>Size L</p>
              <a href="#"><i class="far fa-trash"></i></a>
            </div>
          </div>
          <div class="differentProfilesContainer">
            <div class="individProfile mainProfile">
              <h6>John Doe (Main Account)</h6>
              <div class="individInfoP">
                <p>123 Fake Street</p>
                <p>New York, NY 00000</p>
              </div>
            </div>
            <hr />
            <div class="individProfile">
              <h6>John Doe (Main Account)</h6>
              <div class="individInfoP">
                <p>123 Fake Street</p>
                <p>New York, NY 00000</p>
              </div>
            </div>
          </div>
          <div class="orderReviewContainer">
            <div class="individualInput">
              <h4>Coupon</h4>
              <input type="text" name="" id="" value="freesupreme" />
              <span class="percentOff">
                -$150
              </span>
            </div>
            <div class="individualInput">
              <h4>Items (3)</h4>
              <div class="gridListOfInput">
                <div class="individGridList">
                  <h5>Supreme Backpack</h5>
                  <h5>Size L</h5>
                  <h6>$100</h6>
                </div>
                <div class="individGridList">
                  <h5>Supreme Backpack</h5>
                  <h5>Size L</h5>
                  <h6>$100</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="fixedBottomSidebar">
            <div class="totalsContainer">
              <h5>Total:</h5>
              <h5>$150</h5>
            </div>
            <a href="#">Checkout</a>
          </div>
        </div>
      </div>
      <div class="mobileNavTop">
        <a @click="mixNav" href="#" class="iconBarsMobile"><i class="fas fa-bars"></i></a>
        <div class="logoContainerMobile">
          <a href="#"><img src="../../../assets/images/logo-white.svg" alt="" /></a>
        </div>
        <a href="#" class="iconCartMobile openSidebar"><img src="../../../assets/images/icon-cart.svg" alt="" /></a>
      </div>
      <div class="flexLayoutTop">
        <div class="flexLayoutShopFilter">
          <nav class="flexLayoutShopFilterActual">
            <li><router-link to="/user/account">Account Info</router-link></li>
            <li class="active">
              <router-link to="/user/profiles">Profiles</router-link>
            </li>
            <li>
              <router-link to="/user/orders">Orders</router-link>
            </li>
            <li>
              <router-link to="/logout">Sign Out</router-link>
            </li>
          </nav>
        </div>
        <div class="flexLayoutTopRight">
          <a href="#" class="openSidebar"><img src="../../../assets/images/icon-cart.svg" alt="" /></a>
        </div>
      </div>
      <div class="flexLayoutActualBody">
        <div class="userInfoInAccountContainer">
          <div class="itemBodyLeftModal notModal">
            <div class="personasContainerMultiple">
              <div v-for="(profile,index) in profiles" class="inputsContainer">
                <h2>{{profile.profileName || 'Main Account'}}</h2>
                <a @click="editProfile(profile)" href="#" class="editAccInfo"><i class="far fa-edit"></i> Edit Info</a>
                <div class="multiFlexGridInputs">
                  <div class="individualInput">
                    <h5>Profile Name</h5>
                    <input :value="profile.profileName || 'Main Profile'" type="text" name="" id="" placeholder="Street" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Full Name</h5>
                    <input :value="makeName(profile)" type="text" name="" id="" placeholder="John Doe" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Credit Card</h5>
                    <input :value="last4Card(profile)" type="text" name="" id="" placeholder="123 Cherry Ave" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Address</h5>
                    <input :value="profile.shipping.address1" type="text" name="" id="" placeholder="New York" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>City</h5>
                    <input :value="profile.shipping.city" type="text" name="" id="" placeholder="NY" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>State</h5>
                    <input :value="profile.shipping.state" type="text" name="" id="" placeholder="10001" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Zip</h5>
                    <input :value="profile.shipping.zip" type="text" name="" id="" placeholder="you@example.com" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Email</h5>
                    <input v-model="profile.email" type="text" name="" id="" placeholder="you@example.com" disabled />
                  </div>
                  <!--<div class="individualInput">
                    <li>
                      <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value2" checked />
                      <label for="styled-checkbox-2">Default Profile</label>
                    </li>
                  </div> -->
                </div>
              </div>
              <!-- <div class="inputsContainer">
                <h2>Profile 2</h2>
                <a href="#" class="editAccInfo"><i class="far fa-edit"></i> Edit Info</a>
                <div class="multiFlexGridInputs">
                  <div class="individualInput">
                    <h5>Persona Name</h5>
                    <input type="text" name="" id="" placeholder="Street" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Full Name</h5>
                    <input type="text" name="" id="" placeholder="Street" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Phone Number</h5>
                    <input type="text" name="" id="" placeholder="Street" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Email</h5>
                    <input type="text" name="" id="" placeholder="00000" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Full Name</h5>
                    <input type="text" name="" id="" placeholder="Street" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Phone Number</h5>
                    <input type="text" name="" id="" placeholder="Street" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Email</h5>
                    <input type="text" name="" id="" placeholder="00000" disabled />
                  </div>
                  <div class="individualInput">
                    <h5>Phone Number</h5>
                    <input type="text" name="" id="" placeholder="Street" disabled />
                  </div>
                </div>
              </div> -->
            </div>
            <div class="quickCheckout">
              <a @click="addProfile" href="#">Add Profile</a>
              <!--<small>
                Mauris eros mauris, aliquam ut elementum ut, interdum eu arcu.
                Praesent sodales lacus vitae orci pellentesque, non iaculis
                eros vehicula. Nullam auctor et arcu quis aliquet. Vestibulum
                ante ipsum primis in.
              </small> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
</template>
<script>
export default {
  data() {
    return {
        showNav: false
    }
  },
  created() {
    this.$store.dispatch('profiles/getProfiles')
  },
  computed: {
    profiles() {
      // let {profiles} = this.$store.state.profiles
      // return [profiles[0],profiles[0]]
      return this.$store.state.profiles.profiles
    }
  },
  methods: {
    cardString(profile) {

    },
    last4Card(profile) {
      let { card } = profile
      let { number } = card
      return number.slice(-4)
    },
    makeName(profile) {
      let { shipping } = profile
      if (!shipping) return null
      let { firstName, lastName } = shipping
      let fullName = firstName
      if (lastName) fullName = firstName + ' ' + lastName
      return fullName
    },
    addProfile() {
      console.log(`addProfile called`)
      this.$router.push('/newProfile')
    },
    editProfile(profile) {
      console.log(`editing profile ${profile.profileId}`)
      let url = `/editProfile/${profile.profileId}`
      this.$router.push(url)
      // this.$router.push({path: '/editProfile',params: {id: profile.profileId}})
    },
    mixNav() {
        this.showNav = !this.showNav;
    }
  }

}
</script>
